const emptyDashboardState = {
  lastViewed: [],
  lastSearchedBps: [],
  lastSearchedFiles: [],
  dashboard: {},
  dashboardLoading: false,
}

export default emptyDashboardState
